import { ArrowRight } from "lucide-react";

export const Hero = () => {
  return (
    <section id="top" className="pt-32 pb-20 lg:pt-44 lg:pb-28 overflow-hidden">
      <div className="container mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          <div className="lg:col-span-6">
            <div className="inline-flex items-center gap-2 border border-slate-200 bg-slate-50 px-4 py-2 mb-8">
              <span className="h-2 w-2 bg-blue-600 rounded-full animate-pulse" />
              <span className="text-xs font-semibold uppercase tracking-widest text-slate-600">
                Trusted IT & Security Partner
              </span>
            </div>
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter text-slate-950 leading-[0.95]">
              Secure. <br />
              Connect. <br />
              <span className="text-blue-600">Manage.</span>
            </h1>
            <p className="mt-8 text-lg text-slate-600 leading-relaxed max-w-lg">
              ZID IT Solutions delivers rock-solid network infrastructure, tidy
              structured cabling, and smart security camera systems for
              businesses and homes.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                data-testid="hero-quote-btn"
                className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 transition-colors group"
              >
                Get a Free Quote
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="#services"
                data-testid="hero-services-btn"
                className="inline-flex items-center justify-center border border-slate-300 hover:border-slate-950 text-slate-950 font-semibold px-8 py-4 transition-colors"
              >
                Our Services
              </a>
            </div>
          </div>

          <div className="lg:col-span-6 relative">
            <div className="relative border border-slate-200">
              <img
                src="https://images.pexels.com/photos/37730211/pexels-photo-37730211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Modern server rack in a secure data center"
                className="w-full h-[420px] lg:h-[520px] object-cover"
              />
            </div>
            <div className="absolute -top-4 -right-4 h-24 w-24 bg-amber-400 -z-10 hidden lg:block" />
          </div>
        </div>
      </div>
    </section>
  );
};
